module.exports = {
    API_URL : "https://apis.capnolearning.com/api",
    // API_URL : "https://devapi.capnolearning.com/api", // Dev API Gateway URL
    // API_URL : "http://localhost:3002/api",
    // API_URL : "https://capno-api.herokuapp.com/api",
    SERVER_URL: "https://capnolearning.com",
    FORM_URL: "https://capno-forms.s3.amazonaws.com",
    DATA_URL: "//capno-data.s3.amazonaws.com/",
    ASSOCIATED_OWNER: "2048d4501a8ee60d3d586159d163dbeb"
}

